function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Space, Button, Skeleton, message, Drawer, Modal, Tag, Statistic, Table } from 'antd';
import { NodePlusFill, PencilSquare, TrashFill, CartPlusFill, CardList } from 'react-bootstrap-icons';
import Common from "../components/includes/Common";
import AddCompany from "../components/forms/AddCompany";
import EditCompany from "../components/forms/EditCompany";
import { Icon } from "@iconify/react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Companies = function Companies() {
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    newCompanyVisible = _useState2[0],
    setNewCompanyVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    reportsDrawerVisible = _useState4[0],
    setReportsDrawerVisible = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedCompany = _useState6[0],
    setSelectedCompany = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    companies = _useState8[0],
    setCompanies = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isDataLoading = _useState10[0],
    setIsDataLoading = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    dataChanged = _useState12[0],
    setDataChanged = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showEdit = _useState14[0],
    setShowEdit = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showNewOrder = _useState16[0],
    setShowNewOrder = _useState16[1];
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    totalOrderAmount = _useState18[0],
    setTotalOrderAmount = _useState18[1];
  var _useState19 = useState(0),
    _useState20 = _slicedToArray(_useState19, 2),
    totalPaidAmount = _useState20[0],
    setTotalPaidAmount = _useState20[1];
  var _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    totalDue = _useState22[0],
    setTotalDue = _useState22[1];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Ref"
    }),
    dataIndex: 'ref',
    responsive: ['lg', 'md', 'sm'],
    key: 'ref',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Nom"
    }),
    dataIndex: 'label',
    key: 'label',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Solde"
    }),
    dataIndex: 'balance',
    key: 'balance',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: parseInt(text) >= 0 ? /*#__PURE__*/_jsxs(Tag, {
          color: "#53987A",
          children: [text.toLocaleString("Fr"), " GNF"]
        }) : /*#__PURE__*/_jsxs(Tag, {
          color: "#986553",
          children: [text.toLocaleString("Fr"), " GNF"]
        })
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Tel."
    }),
    dataIndex: 'mobile',
    key: 'mobile',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Adresse"
    }),
    dataIndex: 'address',
    responsive: ['lg', 'md', 'sm'],
    key: 'address',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {}),
    dataIndex: 'action',
    key: 'action',
    render: function render(c) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(Button, {
            type: "link",
            href: "/#/home/companydetails/" + c.id,
            children: /*#__PURE__*/_jsx(CardList, {
              size: 22
            })
          }), /*#__PURE__*/_jsx(Button, {
            type: "link",
            onClick: function onClick() {
              setSelectedCompany(c);
              setShowEdit(true);
            },
            children: /*#__PURE__*/_jsx(PencilSquare, {
              size: 20
            })
          }), ContextHolder, /*#__PURE__*/_jsx(Button, {
            type: "link",
            onClick: function onClick() {
              setSelectedCompany(c);
              confirm({
                title: /*#__PURE__*/_jsx("b", {
                  children: "Confirmez-vous ?"
                }),
                content: /*#__PURE__*/_jsxs("p", {
                  children: ["La suppression de la soci\xE9t\xE9 ", c.label, " avec toutes ses donn\xE9es ?"]
                }),
                onOk: function onOk() {
                  axios.post(Common.baseApiUrl + "deletecompany", {
                    user_id: Common.currentUser.id,
                    id: c.id
                  }).then(function (response) {
                    if (response.data.status == 200) {
                      notification.success({
                        message: "Ok!",
                        description: response.data.message
                      });
                    } else {
                      notification.error({
                        message: "Erreur!",
                        description: response.data.message
                      });
                    }
                  })["catch"](function (error) {
                    notification.error({
                      message: "Erreur!",
                      description: "Une erreur est survenue " + error.toString()
                    });
                  });
                }
              });
            },
            children: /*#__PURE__*/_jsx(TrashFill, {
              size: 20
            })
          })]
        })
      });
    }
  }];
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.get(Common.baseApiUrl + 'getcompanylist/' + Common.currentStation.id + '/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCompanies([]);
        response.data.companyList.forEach(function (c) {
          setCompanies(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              ref: c.id,
              label: c.label,
              balance: c.balance,
              mobile: c.telephone,
              address: c.address,
              action: c
            }]);
          });
          setTotalDue(function (prev) {
            return prev + c.balance;
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 10,
          md: 12,
          children: [/*#__PURE__*/_jsx(Space, {
            direction: "horizontal",
            children: /*#__PURE__*/_jsxs(Button, {
              type: "link",
              onClick: function onClick() {
                setNewCompanyVisible(true);
              },
              icon: /*#__PURE__*/_jsx(NodePlusFill, {}),
              children: [" ", /*#__PURE__*/_jsx("b", {
                children: " CREER UN COMPTE CLIENT"
              })]
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Col, {
              lg: 12,
              md: 12,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  borderRadius: "7px",
                  padding: "15px 12px",
                  textAlign: "center",
                  background: "#E8EFFD"
                },
                children: /*#__PURE__*/_jsx(Statistic, {
                  prefix: /*#__PURE__*/_jsx(Icon, {
                    icon: "flat-color-icons:high-priority",
                    width: "48",
                    height: "48"
                  }),
                  valueStyle: {
                    color: "#010101"
                  },
                  title: /*#__PURE__*/_jsx("b", {
                    style: {
                      color: '#010101'
                    },
                    children: "Total impay\xE9s"
                  }),
                  value: totalDue
                })
              })
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
            className: "cool-radius white-bg",
            children: /*#__PURE__*/_jsx(Table, {
              columns: cols,
              dataSource: companies,
              loading: isDataLoading,
              bordered: true,
              size: "small"
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: newCompanyVisible,
      width: 370,
      destroyOnClose: true,
      title: "Ajouter une entreprise",
      onClose: function onClose() {
        setNewCompanyVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(AddCompany, {
        handler: function handler() {
          setDataChanged(true);
          setNewCompanyVisible(false);
        }
      })
    }), selectedCompany && /*#__PURE__*/_jsx(Drawer, {
      open: showEdit,
      width: 370,
      destroyOnClose: true,
      title: "Modifier",
      onClose: function onClose() {
        setShowEdit(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(EditCompany, {
        company: selectedCompany,
        handler: function handler() {
          setDataChanged(true);
          setShowEdit(false);
          notification.success({
            message: "Ok!",
            description: "Opération réussie !"
          });
        }
      })
    })]
  });
};
export default Companies;